import { ApiQueryBuilder } from "@/hooks/use-api-query";
import { ITenantUserResponse } from "@portafino/shared";
import { QueryKey } from "@/utils/query-key";

export const GetAuthenticatedTenantUser: ApiQueryBuilder<ITenantUserResponse, void> = () => {
    return {
        queryKey: [QueryKey.AuthenticatedTenantUser],
        queryFn: async (apiClient) => {
            const response = await apiClient.get<ITenantUserResponse>(`/tenants/auth/me`)
            return response.data
        }
    }
}